import React, { useEffect, useState } from 'react';
import { fetchVendeursEnAttente } from '../../services/vendeurs/vendeurAdminService';
import '../../styles/admin/ListeVendeurValides.css';

function VendeurList({ onSelect }) {
  const [vendeurs, setVendeurs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await fetchVendeursEnAttente();
        setVendeurs(data || []);
      } catch (err) {
        console.error('Erreur chargement vendeurs :', err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="mes-produits-container">
      <div className="mes-produits-header">
        <h2>Demandes d’inscription des vendeurs</h2>
      </div>

      {loading ? (
        <p>Chargement…</p>
      ) : vendeurs.length === 0 ? (
        <p className="empty-state">Aucune demande d’inscription en attente.</p>
      ) : (
        <div className="table-responsive">
          <table className="mes-produits-table">
            <colgroup>
              <col /> 
              <col /> 
              <col style={{ width: '140px' }} /> 
              <col style={{ width: '130px' }} /> 
            </colgroup>

            <thead>
              <tr>
                <th>Nom</th>
                <th>Email</th>
                <th>Téléphone</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {vendeurs.map((v) => (
                <tr key={v.id}>
                  <td data-label="Nom">{v.nom} {v.prenom}</td>
                  <td data-label="Email">{v.email}</td>
                  <td data-label="Téléphone">{v.telephone}</td>
                  <td data-label="Action" className="action-buttons">
                    <button className="btn-primary" onClick={() => onSelect(v)}>
                      📄 Voir détails
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default VendeurList;
